import { UsersFormData } from './data/UsersFormData';
import { UsersFormState } from './state/UsersFormState';

export class UsersForm {
    data: UsersFormData = new UsersFormData();
    state: UsersFormState = new UsersFormState();
    doValidation: boolean = false;
}
